import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from '@/components/common/CustomLink'

export function BackToLoginLink() {
  const { t } = useTranslation()

  return (
    <div className='flex items-center justify-center pt-2'>
      <Link
        to='/login'
        className='flex items-center gap-2 text-sm text-dark-600 hover:text-dark-900 font-bold'
      >
        <ArrowLeft className='w-4 h-4' />
        {t('auth.backToLogin')}
      </Link>
    </div>
  )
}
